// frontend/src/askos/PerformanceSnapshotCard.js
//
// Real data from GET /tenant/{slug}/askos/performance/snapshot, combining
// StudentActivityEvent + PYQAttempt + MockAttempt.
import React, { useEffect, useState } from 'react';
import { getPerformanceSnapshot } from '../api/performanceApi';

const TILES = [
    { key: 'questions_attempted', label: 'Questions Attempted', fmt: v => v },
    { key: 'accuracy_pct', label: 'Accuracy', fmt: v => `${v}%` },
    { key: 'study_time_min', label: 'Study Time', fmt: v => `${v}m` },
    { key: 'topics_covered', label: 'Topics Covered', fmt: v => v },
];

const Sparkline = ({ daily }) => {
    if (!daily || daily.length === 0) return null;
    const max = Math.max(1, ...daily.map(d => d.count));
    const bars = ['▁', '▂', '▃', '▄', '▅', '▆', '▇', '█'];
    const str = daily.map(d => bars[Math.min(bars.length - 1, Math.floor((d.count / max) * (bars.length - 1)))]).join('');
    return <div className="sparkline">{str}</div>;
};

const PerformanceSnapshotCard = ({ slug }) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        getPerformanceSnapshot(slug, 'week').then(setData).catch(() => setData(null));
    }, [slug]);

    return (
        <article className="panel">
            <div className="panel-heading">
                <h3>Performance Snapshot</h3>
            </div>
            <div className="metric-grid">
                {TILES.map(t => {
                    const metric = data?.[t.key];
                    return (
                        <div key={t.key} className="metric-card">
                            <span>{t.label}</span>
                            <strong>{metric ? t.fmt(metric.value) : '—'}</strong>
                            {metric && (
                                <small>{metric.delta_pct >= 0 ? '↑' : '↓'} {Math.abs(metric.delta_pct)}%</small>
                            )}
                            {!metric && <small>Coming soon</small>}
                        </div>
                    );
                })}
            </div>
            <Sparkline daily={data?.daily} />
        </article>
    );
};

export default PerformanceSnapshotCard;
